<div class="w-full mx-auto p-5 space-y-5">

  <!-- Header -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Tesorería</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Excedentes</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Excedentes de Pago</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ filteredExcessPayments.length }} excedentes · Gestión de pagos en exceso por participantes y empresas
      </p>
    </div>
    <button (click)="refreshData()" [disabled]="loading" class="btn btn-secondary">
      <svg class="w-4 h-4" [class.animate-spin]="loading" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      Actualizar
    </button>
  </div>

  <!-- Toolbar de filtros -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <div class="col-span-12 md:col-span-5">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()"
            placeholder="Buscar por participante, empresa o proyecto..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <div class="col-span-6 md:col-span-3">
        <select [(ngModel)]="statusFilter" (change)="onStatusFilterChange()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <div class="col-span-6 md:col-span-3">
        <select [(ngModel)]="excessTypeFilter" (change)="onExcessTypeFilterChange()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option *ngFor="let option of excessTypeOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <div class="col-span-12 md:col-span-1 flex items-center justify-end text-xs text-slate-500 tabular-nums">
        <span *ngIf="searchTerm || statusFilter || excessTypeFilter">
          de <strong class="text-slate-700">{{ excessPayments.length }}</strong>
        </span>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="bg-white border border-slate-200 rounded-xl p-10 text-center">
    <app-loading-spinner></app-loading-spinner>
  </div>

  <!-- Tabla -->
  <div *ngIf="!loading" class="rounded-xl border border-slate-200 bg-white overflow-x-auto">
    <table class="enrollment-table">
      <thead>
        <tr>
          <th>Pagador</th>
          <th>Tipo</th>
          <th>Proyecto</th>
          <th>Comprobante origen</th>
          <th class="text-right">Fecha</th>
          <th class="text-right">Monto excedente</th>
          <th class="text-right">Disponible</th>
          <th>Estado</th>
          <th>Auditoría</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>

        <tr *ngFor="let excessPayment of getPaginatedData()">
          <!-- Pagador -->
          <td>
            <div class="participant-cell">
              <div class="initials-avatar"
                [class.tone-a]="!excessPayment.isCorporatePayment"
                [class.tone-d]="excessPayment.isCorporatePayment">
                <svg *ngIf="!excessPayment.isCorporatePayment" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <svg *ngIf="excessPayment.isCorporatePayment" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1" />
                </svg>
              </div>
              <div class="participant-meta">
                <div class="participant-name">{{ getPayerName(excessPayment) }}</div>
                <div class="participant-email tabular-nums">{{ getPayerDocumentId(excessPayment) }}</div>
              </div>
            </div>
          </td>

          <!-- Tipo -->
          <td>
            <span class="pill" [ngClass]="excessPayment.isCorporatePayment ? 'pill-violet' : 'pill-sky'">
              {{ getPayerType(excessPayment) }}
            </span>
          </td>

          <!-- Proyecto -->
          <td>
            <div class="project-chip">
              <span class="project-code">{{ excessPayment.project.projectId }}</span>
              <span class="project-name" [title]="excessPayment.project.name">{{ excessPayment.project.name }}</span>
            </div>
          </td>

          <!-- Comprobante origen -->
          <td>
            <div class="data-cell">
              <span class="data-value">{{ excessPayment.originIncomeReceipt.referenceNumber || 'Sin referencia' }}</span>
              <span class="data-sub tabular-nums">{{ formatDate(excessPayment.originIncomeReceipt.createdAt) }}</span>
            </div>
          </td>

          <!-- Fecha excedente -->
          <td class="text-right text-slate-600 tabular-nums">{{ formatDate(excessPayment.excessDate) }}</td>

          <!-- Monto excedente -->
          <td class="text-right font-semibold text-slate-900 tabular-nums">
            {{ formatCurrency(excessPayment.excessAmount, getCurrencyCode(excessPayment)) }}
          </td>

          <!-- Disponible -->
          <td class="text-right font-semibold text-emerald-700 tabular-nums">
            {{ formatCurrency(excessPayment.availableAmount, getCurrencyCode(excessPayment)) }}
          </td>

          <!-- Estado -->
          <td>
            <span class="pill"
              [ngClass]="{
                'pill-emerald': excessPayment.status === 'Available' || excessPayment.status === 'Active',
                'pill-amber':   excessPayment.status === 'PartiallyUsed' || excessPayment.status === 'Pending',
                'pill-rose':    excessPayment.isExpired || excessPayment.status === 'Expired' || excessPayment.status === 'Refunded',
                'pill-neutral': excessPayment.status === 'Used' || excessPayment.status === 'Closed'
              }">
              {{ excessPayment.statusDescription }}
            </span>
            <span *ngIf="excessPayment.isExpired" class="block text-[10px] text-rose-600 mt-0.5 font-semibold uppercase tracking-wider">
              Expirado
            </span>
          </td>

          <!-- Auditoría -->
          <td>
            <app-audit-info [auditData]="getAuditData(excessPayment)" layout="compact" size="sm"></app-audit-info>
          </td>

          <!-- Acciones -->
          <td class="text-right">
            <div class="inline-flex items-center gap-1">
              <button (click)="viewFinancialSummary(excessPayment)" class="row-action" title="Resumen financiero">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
                <span>Resumen</span>
              </button>
              <button (click)="viewDetail(excessPayment)" class="row-action row-action--primary" title="Ver detalle">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
                <span>Detalle</span>
              </button>
            </div>
          </td>
        </tr>

        <!-- Empty state -->
        <tr *ngIf="filteredExcessPayments.length === 0">
          <td colspan="10" class="text-center py-10">
            <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <p class="text-sm font-medium text-slate-700">No se encontraron excedentes</p>
            <p class="text-xs text-slate-500 mt-1">
              <span *ngIf="searchTerm || statusFilter">Probá con otros filtros de búsqueda.</span>
              <span *ngIf="!searchTerm && !statusFilter">No hay excedentes registrados en el sistema.</span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginación -->
  <div *ngIf="!loading && filteredExcessPayments.length > 0"
    class="bg-white rounded-xl border border-slate-200 px-4 py-3 flex items-center justify-between text-sm">
    <p class="text-slate-600 tabular-nums">
      Mostrando <strong>{{ (currentPage - 1) * itemsPerPage + 1 }}</strong> –
      <strong>{{ Math.min(currentPage * itemsPerPage, totalItems) }}</strong> de
      <strong>{{ totalItems }}</strong>
    </p>
    <nav class="inline-flex items-center gap-1" aria-label="Pagination">
      <button (click)="previousPage()" [disabled]="currentPage === 1" class="btn btn-ghost btn-sm">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </button>
      <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
        class="btn btn-sm" [ngClass]="currentPage === i + 1 ? 'btn-primary' : 'btn-ghost'"
        style="min-width: 36px; padding: 0;">
        <span class="tabular-nums">{{ i + 1 }}</span>
      </button>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="btn btn-ghost btn-sm">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
        </svg>
      </button>
    </nav>
  </div>

  <!-- ============================================================ -->
  <!-- Modal Resumen Financiero                                     -->
  <!-- ============================================================ -->
  <div *ngIf="showFinancialSummaryModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-300" (click)="closeFinancialSummaryModal()"></div>
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 relative">
      <div class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-3xl">

        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <h3 class="text-base font-semibold text-slate-900 flex items-center gap-2">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            Resumen Financiero del Pago
          </h3>
          <button (click)="closeFinancialSummaryModal()" class="text-slate-400 hover:text-slate-700 transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingFinancialSummary" class="flex justify-center items-center py-12">
          <svg class="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          <span class="ml-3 text-slate-600 text-sm">Cargando resumen financiero…</span>
        </div>

        <!-- Content -->
        <div *ngIf="!loadingFinancialSummary && selectedPaymentGroupSummary" class="p-5 space-y-5 max-h-[70vh] overflow-y-auto">

          <!-- Info general -->
          <div class="bg-slate-50 border border-slate-200 rounded-xl p-4">
            <h4 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Información general</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div>
                <span class="text-xs text-slate-500">Fecha del pago</span>
                <p class="text-slate-800 tabular-nums">{{ formatDate(selectedPaymentGroupSummary.paymentDate) }}</p>
              </div>
              <div>
                <span class="text-xs text-slate-500">ID del grupo</span>
                <p class="font-mono text-xs text-slate-700">{{ selectedPaymentGroupSummary.paymentGroupId }}</p>
              </div>
              <div class="md:col-span-2">
                <span class="text-xs text-slate-500">Concepto</span>
                <p class="text-slate-800">{{ selectedPaymentGroupSummary.originalConcept }}</p>
              </div>
            </div>
          </div>

          <!-- KPIs -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div class="kpi-card kpi-emerald">
              <div class="kpi-label">
                <span class="kpi-icon"><i class="fas fa-arrow-down"></i></span>
                Total Recibido
              </div>
              <div class="kpi-value">{{ formatCurrency(selectedPaymentGroupSummary.totalReceivedAmount, selectedPaymentGroupSummary.currencyCode) }}</div>
            </div>
            <div class="kpi-card kpi-sky">
              <div class="kpi-label">
                <span class="kpi-icon"><i class="fas fa-clipboard-check"></i></span>
                Aplicado a cuotas
              </div>
              <div class="kpi-value">{{ formatCurrency(selectedPaymentGroupSummary.totalAppliedAmount, selectedPaymentGroupSummary.currencyCode) }}</div>
              <div class="kpi-hint tabular-nums">{{ selectedPaymentGroupSummary.installmentsPaid }} cuota(s)</div>
            </div>
            <div class="kpi-card kpi-amber">
              <div class="kpi-label">
                <span class="kpi-icon"><i class="fas fa-balance-scale"></i></span>
                Excedente
              </div>
              <div class="kpi-value">{{ formatCurrency(selectedPaymentGroupSummary.totalExcessAmount, selectedPaymentGroupSummary.currencyCode) }}</div>
            </div>
          </div>

          <!-- Flujo visual -->
          <div class="bg-white border border-slate-200 rounded-xl p-4">
            <h4 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">Flujo del dinero</h4>
            <div class="flex items-center justify-center gap-4 flex-wrap">
              <div class="flow-step flow-step--in">
                <span class="flow-icon"><i class="fas fa-credit-card"></i></span>
                <span class="flow-label">Recibido</span>
                <span class="flow-amount">{{ formatCurrency(selectedPaymentGroupSummary.totalReceivedAmount, selectedPaymentGroupSummary.currencyCode) }}</span>
              </div>
              <span class="flow-arrow">→</span>
              <div class="flow-step flow-step--apply">
                <span class="flow-icon"><i class="fas fa-clipboard-check"></i></span>
                <span class="flow-label">Aplicado</span>
                <span class="flow-amount">{{ formatCurrency(selectedPaymentGroupSummary.totalAppliedAmount, selectedPaymentGroupSummary.currencyCode) }}</span>
              </div>
              <ng-container *ngIf="selectedPaymentGroupSummary.totalExcessAmount > 0">
                <span class="flow-arrow">→</span>
                <div class="flow-step flow-step--excess">
                  <span class="flow-icon"><i class="fas fa-balance-scale"></i></span>
                  <span class="flow-label">Excedente</span>
                  <span class="flow-amount">{{ formatCurrency(selectedPaymentGroupSummary.totalExcessAmount, selectedPaymentGroupSummary.currencyCode) }}</span>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Detalle de cuotas pagadas -->
          <div class="rounded-xl border border-slate-200 overflow-hidden">
            <div class="px-4 py-3 bg-slate-50 border-b border-slate-200">
              <h4 class="text-xs font-semibold text-slate-600 uppercase tracking-wider">Detalle de cuotas pagadas</h4>
            </div>
            <table class="enrollment-table">
              <thead>
                <tr>
                  <th>Cuota</th>
                  <th class="text-right">Monto</th>
                  <th>Estado</th>
                  <th class="text-right">Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let receipt of selectedPaymentGroupSummary.incomeReceipts">
                  <td class="font-medium tabular-nums">#{{ receipt.installmentNumber }}</td>
                  <td class="text-right font-medium tabular-nums">{{ formatCurrency(receipt.grossAmount, selectedPaymentGroupSummary.currencyCode) }}</td>
                  <td>
                    <span class="pill" [ngClass]="getPaymentStatusClass(receipt.paymentPlanStatus)">
                      {{ receipt.paymentPlanStatus }}
                    </span>
                  </td>
                  <td class="text-right text-slate-600 tabular-nums">{{ formatDate(receipt.createdAt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Estado del excedente -->
          <div *ngIf="selectedPaymentGroupSummary.excessPayment"
            class="alert-banner alert-amber">
            <i class="fas fa-exclamation-circle alert-icon"></i>
            <div class="alert-body">
              <p class="alert-title">Estado del excedente</p>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-2 text-sm">
                <div>
                  <span class="text-xs font-semibold uppercase tracking-wider opacity-70 block">Disponible</span>
                  <span class="font-bold tabular-nums">{{ formatCurrency(selectedPaymentGroupSummary.excessPayment.availableAmount, selectedPaymentGroupSummary.currencyCode) }}</span>
                </div>
                <div>
                  <span class="text-xs font-semibold uppercase tracking-wider opacity-70 block">Utilizado</span>
                  <span class="font-bold tabular-nums">{{ formatCurrency(selectedPaymentGroupSummary.excessPayment.usedAmount, selectedPaymentGroupSummary.currencyCode) }}</span>
                </div>
                <div>
                  <span class="text-xs font-semibold uppercase tracking-wider opacity-70 block">Estado</span>
                  <span class="font-bold" [ngClass]="selectedPaymentGroupSummary.excessPayment.isExpired ? 'text-rose-700' : 'text-emerald-700'">
                    {{ selectedPaymentGroupSummary.excessPayment.status }}
                  </span>
                </div>
                <div *ngIf="selectedPaymentGroupSummary.excessPayment.expirationDate" class="md:col-span-3">
                  <span class="text-xs font-semibold uppercase tracking-wider opacity-70 block">Fecha de expiración</span>
                  <span class="tabular-nums">{{ formatDate(selectedPaymentGroupSummary.excessPayment.expirationDate) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="bg-slate-50 px-5 py-3 flex justify-end border-t border-slate-200">
          <button (click)="closeFinancialSummaryModal()" class="btn btn-secondary">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>
